<template>
    <div class="carousel px-0" :class="carrouselContainer">
        <CarouselSlider
            v-for="(banner, i) in banners"
            :key="i"
            :slide="banner"
            :slide-index="i"
            :current-index="index"
            :direction="direction"
            :home="home"
        />
        <slot></slot>
        <div
            class="carousel__nav carousel__next d-flex align-items-center"
            v-if="slideIndicators"
            :style="$bgColor(color.primary)"
            @click.prevent="next">
            <i class="corousel__nav_icon fas fa-chevron-right m-auto"></i>
        </div>
        <div
            class="carousel__nav carousel__prev d-flex align-items-center"
            v-if="slideIndicators"
            :style="$bgColor(color.primary)"
            @click.prevent="prev">
            <i class="corousel__nav_icon fas fa-chevron-left m-auto"></i>
        </div>
        <div class="carousel__pagination" v-if="slideIndicators">
            <button v-for="n in slidesCount" @click="goTo(n-1)" :class="{active: n-1 === index}" :key="n"></button>
        </div>
    </div>
</template>

<script>
import CarouselSlider from "../Carousel/CarouselSlider"

export default {
    components: {
        CarouselSlider,
    },
    props: {
        content: {
            type: Object,
            required: true
        },
        home: {
            type: Boolean
        }
    },
    data() {
        return {
            index: 0,
            direction: null,
            interval: Function,
            banners: this.content.contents
        }
    },
    computed: {
        carrouselContainer() {
            if (this.content.styles.container) return "container";
        },
        slideIndicators() {
            if (this.banners.length > 1) return true;
        },
        slidesCount() {
            return this.banners.length;
        },
        color() {
            return this.$store.getters.COLOR;
        }
    },
    methods: {
        next() {
            this.index++;
            this.direction = "right";
            if (this.index >= this.slidesCount) return (this.index = 0);
        },
        prev() {
            this.index--;
            this.direction = "left";
            if (this.index < 0) return (this.index = this.slidesCount - 1);
        },
        goTo(index) {
            this.direction = index > this.index ? "right" : "left";
            this.index = index;
        }
    },
    mounted() {
        if (this.banners.length > 1) {
            this.interval = setInterval(() => this.next(), 8000);
        }
    }
};
</script>

<style scoped>
.corousel__nav_icon {
    color: #fff;
    font-size: 1.5rem;
}

button {
    display: inline-block;
    border: none;
    margin: 0;
    text-decoration: none;
    background: #0069ed;
    color: #ffffff;
    font-family: sans-serif;
    font-size: 1rem;
    cursor: pointer;
    text-align: center;
    transition: background 250ms ease-in-out, transform 150ms ease;
    -webkit-appearance: none;
    -moz-appearance: none;
}

button:hover,
button:focus {
    background: #0053ba;
}

button:focus {
    outline: 1px solid #fff;
    outline-offset: -4px;
}

button:active {
    transform: scale(0.99);
}

.carousel {
    position: relative;
    overflow: hidden;
}

.carousel__nav {
    position: absolute;
    margin-top: -33px;
    border-radius: 50px;
    cursor: pointer;
    top: 50%;
    left: 20px;
    width: 40px;
    height: 40px;
    opacity: 0.3;
}

.carousel__nav.carousel__next {
    right: 20px;
    left: auto;
}

.carousel__pagination {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    text-align: center;
}

.carousel__pagination button {
    display: inline-block;
    width: 20px;
    height: 3px;
    background-color: rgb(65, 63, 63);
    opacity: 0.8;
    border-radius: 25px;
    margin: 0 2px;
}

.carousel__pagination button.active {
    background-color: rgb(255, 255, 255);
}
</style>
